import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AdminCenterPage from "@/pages/admin/sections/AdminCenterPage";
import AdminBatchPage from "@/pages/admin/sections/AdminBatchPage";
import AdminStudentMappingPage from "@/pages/admin/sections/AdminStudentMappingPage";

export default function AdminAcademyPage({
  newCenterData,
  setNewCenterData,
  handleCreateCenter,
  centersList,
  selectedCenterForBatch,
  setSelectedCenterForBatch,
  fetchCenterBatches,
  newBatchName,
  setNewBatchName,
  handleCreateBatch,
  centerBatches,
  bulkMappingData,
  setBulkMappingData,
  fetchMappingBatches,
  mappingBatches,
  selectedStudentIds,
  unassignedStudents,
  handleSelectAllUnassigned,
  toggleStudentSelection,
  handleBulkAssignStudents,
}) {
  return (
    <Tabs defaultValue="centers" className="w-full">
      <TabsList className="grid w-full max-w-2xl grid-cols-3 bg-slate-200 mb-6">
        <TabsTrigger value="centers" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white">
          Centers
        </TabsTrigger>
        <TabsTrigger value="batches" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white">
          Batches
        </TabsTrigger>
        <TabsTrigger value="mapping" className="data-[state=active]:bg-slate-900 data-[state=active]:text-white">
          Student Mapping
        </TabsTrigger>
      </TabsList>

      <TabsContent value="centers">
        <AdminCenterPage
          newCenterData={newCenterData}
          setNewCenterData={setNewCenterData}
          handleCreateCenter={handleCreateCenter}
          centersList={centersList}
        />
      </TabsContent>

      <TabsContent value="batches">
        <AdminBatchPage
          centersList={centersList}
          selectedCenterForBatch={selectedCenterForBatch}
          setSelectedCenterForBatch={setSelectedCenterForBatch}
          fetchCenterBatches={fetchCenterBatches}
          newBatchName={newBatchName}
          setNewBatchName={setNewBatchName}
          handleCreateBatch={handleCreateBatch}
          centerBatches={centerBatches}
        />
      </TabsContent>

      <TabsContent value="mapping">
        <AdminStudentMappingPage
          bulkMappingData={bulkMappingData}
          setBulkMappingData={setBulkMappingData}
          fetchMappingBatches={fetchMappingBatches}
          centersList={centersList}
          mappingBatches={mappingBatches}
          selectedStudentIds={selectedStudentIds}
          unassignedStudents={unassignedStudents}
          handleSelectAllUnassigned={handleSelectAllUnassigned}
          toggleStudentSelection={toggleStudentSelection}
          handleBulkAssignStudents={handleBulkAssignStudents}
        />
      </TabsContent>
    </Tabs>
  );
}
